<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShow)="onShow()"
  [modal]="true"
  [style]="{ width: '750px' }"
  header="Edit Vehicle"
>
  <div class="ui-g" style="position: relative" *ngIf="!isLoadingVehicle; else loading">
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Registration Number *</label>
      </div>
      <div class="ui-grid-col-6">
        <div class="ui-inputgroup">
          <input
            [style]="{ width: '100%' }"
            pInputText
            maxlength="30"
            [formControl]="form.controls.registrationNumber"
          />
          <button
            pButton
            (click)="searchVehicle()"
            icon="fa ui-icon-search"
            style="margin-left: 15px; vertical-align: super"
            [disabled]="form.controls.registrationNumber.invalid"
          ></button>
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>VIN *</label>
      </div>
      <div class="ui-grid-col-6">
        <input [style]="{ width: '100%' }" pInputText [formControl]="form.controls.vin" />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Make *</label>
      </div>
      <div class="ui-grid-col-6">
        <input
          [style]="{ width: '100%' }"
          pInputText
          maxlength="30"
          [formControl]="form.controls.make"
        />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Model *</label>
      </div>
      <div class="ui-grid-col-6">
        <input
          [style]="{ width: '100%' }"
          pInputText
          maxlength="30"
          [formControl]="form.controls.model"
        />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Fuel Type *</label>
      </div>
      <div class="ui-grid-col-6">
        <p-dropdown
          id="fuelType"
          class="fuel-type-dropdown"
          [formControl]="form.controls.fuelType"
          [options]="fuelTypes"
          required
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Kerb Weight (kg) *</label>
      </div>
      <div class="ui-grid-col-6">
        <input
          [style]="{ width: '100%' }"
          pInputText
          type="number"
          maxlength="10"
          [formControl]="form.controls.kerbWeight"
        />
        <small *ngIf="noKerbWeightFound" class="text-danger">
          Unable to find the kerb weight, please ensure the existing value is correct.
        </small>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Colour</label>
      </div>
      <div class="ui-grid-col-6">
        <input
          [style]="{ width: '100%' }"
          pInputText
          maxlength="10"
          [formControl]="form.controls.color"
        />
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-6">
        <label>Body</label>
      </div>
      <div class="ui-grid-col-6">
        <input
          [style]="{ width: '100%' }"
          pInputText
          maxlength="30"
          [formControl]="form.controls.body"
        />
      </div>
    </div>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        (click)="saveVehicle()"
        [disabled]="saveDisabled"
        class="btn-to-right"
        label="Save"
        pButton
        type="button"
      ></button>
      <button
        (click)="visibleChange.emit(false)"
        class="ui-button btn-to-right ui-button-tertiary"
        label="Cancel"
        pButton
        type="button"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<ng-template #loading>
  <div
    class="flex align-items-center justify-content-center w-full"
    style="height: 270px; font-size: 25px"
  >
    <i class="fa fa-spin fa-spinner"></i>
  </div>
</ng-template>
